import { useWeb3React } from "@web3-react/core";


export default function useActiveWeb3React() {
  return useWeb3React();
}
